import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrimeNgModule } from '@g99-product-web-ui/prime-ng';
import { SharedUiModule } from '@g99-product-web-ui/shared-ui';

import { ClientHeaderComponent } from './components/client-header/client-header.component';
import { MobileHeaderComponent } from './components/client-header/mobile-header-component/mobile-header.component';
import { NavMenuComponent } from './components/client-header/nav-menu/nav-menu.component';
import { NotificationButtonComponent } from './components/client-header/notification-button/notification-button.component';
import { EmptyNotificationScreenComponent } from './components/client-header/notification-popup/empty-notification-screen/empty-notification-screen.component';
import { NotificationCardComponent } from './components/client-header/notification-popup/notification-card/notification-card.component';
import { NotificationListComponent } from './components/client-header/notification-popup/notification-list/notification-list.component';
import { NotificationPopupComponent } from './components/client-header/notification-popup/notification-popup.component';
import { TedChatComponent } from './components/client-header/notification-popup/ted-chat/ted-chat.component';
import { ProfilePopoverContainerComponent } from './components/client-header/profile-popover-container/profile-popover-container.component';
import { TedButtonComponent } from './components/client-header/ted-button/ted-button.component';
import { TedPopupComponent } from './components/client-header/ted-popup/ted-popup.component';
import { GoogleSetupBannerComponent } from './components/google-setup-banner/GoogleSetupBanner.component';
import { HeaderPopoverComponent } from './components/header-popover/header-popover.component';
import { NotificationSkeletonComponent } from './components/skeletons/notification-skeleton/notification-skeleton.component';
import { TwilioSetupBannerComponent } from './components/twilio-setup-banner/twilio-setup-banner.component';

@NgModule({
  imports: [
    CommonModule,
    PrimeNgModule,
    SharedUiModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [
    ClientHeaderComponent,
    HeaderPopoverComponent,
    ProfilePopoverContainerComponent,
    MobileHeaderComponent,
    NavMenuComponent,
    TwilioSetupBannerComponent,
    GoogleSetupBannerComponent,
    NotificationButtonComponent,
    NotificationPopupComponent,
    TedButtonComponent,
    TedChatComponent,
    TedPopupComponent,
    NotificationSkeletonComponent,
    NotificationCardComponent,
    NotificationListComponent,
    EmptyNotificationScreenComponent,
  ],
  exports: [
    ClientHeaderComponent,
    TwilioSetupBannerComponent,
    GoogleSetupBannerComponent,
  ],
})
export class LayoutLibModule {}
